// style
import "./PaymentListItem.scss";

// price separator
import { addCommas, removeCommas } from "@persian-tools/persian-tools";

// helper functions
import { TimeStampToJalali } from "../../../utilities/helperFunctions";

export default function PaymentListItem({
  title,
  payType = "online",
  payResult,
  price,
  timestamp,
  currency = "تومان",
}) {
  const paymentResult = (type) => {
    if (type == "success") {
      return (
        <label className="success-payment d-flex align-items-start">
          <span className="desc-m">موفق</span>
        </label>
      );
    } else if (type == "failed") {
      return (
        <label className="failed-payment d-flex align-items-start">
          <span className="desc-m">ناموفق</span>
        </label>
      );
    }
  };
  const paymentType = (type) => {
    if (type == "online") {
      return <>پرداخت‌آنلاین</>;
    } else if (type == "offline") {
      return <>پرداخت‌حضوری</>;
    }
  };

  return (
    <div className="payment-list-item d-flex flex-column">
      <div className="first-row d-flex align-items-center justify-content-between w-100">
        <div className="title title-h5-m">{title}</div>
        <div className="time d-flex align-items-center justify-content-end">
          <div className="hour desc-l mr-l-12">
            {TimeStampToJalali(timestamp * 1000, "HH:mm")}
          </div>
          <div className="separator">|</div>
          <div className="date desc-l mr-r-12">
            {TimeStampToJalali(timestamp * 1000, "YYYY/MM/DD ")}
          </div>
        </div>
      </div>
      <div className="second-row d-flex align-items-center justify-content-between w-100 ">
        <div className="payment d-flex align-items-center ">
          <div className="pay-type desc-l">{paymentType(payType)}</div>
          <div>{paymentResult(payResult)}</div>
        </div>

        <div className="price d-flex align-items-center justify-content-end title-h5-m">
          <div className="num title-h5-m">{addCommas(price)}</div>
          <div className="currency desc-l">{currency}</div>
        </div>
      </div>
    </div>
  );
}
